<p>qrcode-ex works!</p>
<h1>How to Generate QR Code in Angular? - ItSolutionStuff.com</h1>
   
<!-- <qrcode [qrdata]="'myAngularxQrCode'" [width]="256" [errorCorrectionLevel]="'M'"></qrcode> -->
<!-- https://remotestack.io/angular-qr-code-generator-tutorial-with-example/ -->
<qr-code [value]="'www.remotestack.io'"></qr-code>
